<template>
  <div>
    <el-button
      type="warning"
      @click="addCLassForStu"
      :size="btnSize"
      :disabled="btnDisable"
      icon="user"
    >
      <slot></slot>
    </el-button>
    <Modal v-model="modalShow" width="480" footer-hide>
      <p slot="header" style="text-align: center; font-size: 15px">
        <Icon type="ios-information-circle"></Icon>
        <span>
          <slot></slot>
        </span>
      </p>
      <el-form :inline="true" :model="formStu" label-width="100px">
        <el-form-item label="选择已有分组:">
          <el-select v-model="formStu.groupId" clearable style="width: 175px">
            <el-option
              v-for="item in groupList"
              :key="item.id"
              :label="item.group_name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <Divider />
      <el-button type="primary" @click="modalConfirm" style="margin-left: 266px"
        >确定</el-button
      >
      <el-button type="primary" @click="modalCancel">取消</el-button>
    </Modal>
  </div>
</template>

<script>
export default {
  name: "classGroup",
  data() {
    return {
      modalShow: false,
      loading: true,
      formStu: {
        groupId: "",
      },
      groupList:[]
      // statusList: [
      //   {
      //     value: 0,
      //     label: "注册",
      //   },
      //   {
      //     value: 1,
      //     label: "激活",
      //   },
      //   {
      //     value: 2,
      //     label: "活跃",
      //   },
      //   {
      //     value: 3,
      //     label: "到期",
      //   },
      //   {
      //     value: 4,
      //     label: "注销",
      //   },
      // ],
    };
  },
  props: {
    btnDisable: {
      type: Boolean,
      default: false,
    },
    btnSize: {
      type: String,
      default: "mini",
    },
    len: {
      type: Number,
      default: 1,
    },
    classId:{
      type: Number,
      default: 1,
    }
  },
  created() {},
  watch: {},
  methods: {
    addCLassForStu() {
      if (this.len == 0) {
        alert("请先选择学生");
        return;
      } else {
        this.modalShow = true;
        this.initData();
      }
    },
    initData() {
      let params = {
        appId: this.$API.APPID,
        classId:this.classId.toString()
      };
      this.eduAxiosPostRequest("/edu/eduAdmin/class/group_list", params).then(
        (res) => {
          if (res != null) {
            let m = JSON.parse(res);
            this.groupList = m.list
             this.groupList.unshift({
               id:0,
               group_name:"取消分组"
             })
          //  debugger
          }
          this.loading = false;
        }
      );
    },
    modalConfirm() {
      // if (this.formStu.groupId== "") {
      //   alert("请选择分组");
      //   return;
      // } else {
        //   传值
       
        this.$emit("classGroupResult", {
          groupId:  parseInt(this.formStu.groupId),
        });

        this.modalShow = false;
      // }
    },
    modalCancel() {
      this.modalShow = false;
    },
        eduAxiosPostRequest(address, params) {
      return new Promise((resolve, reject) => {
        this.$axios
          .post(address, params)
          .then((response) => {
            // console.log(response);
            if (response.data.rc == "0") {
              resolve(JSON.stringify(response.data.data));
            } else {
              alert(response.data.rc + ". " + response.data.err);
              reject(null);
            }
          })
          .catch((error) => {
            ApiMessage(this, error.toString(), "error");
            reject(null);
          });
      });
    },
  },
};
</script>

<style lang="less">
</style>


// WEBPACK FOOTER //
// classGroup.vue?1fea6744